<template>
	<div class="header">
		<div class="a">
			<div class="aa">当前区域：</div>
			<div v-if="adminInfo" class="city">{{adminInfo.region_name}}</div>
			<div v-else class="city">-</div>
			<div class="date">
				<div v-if="!date" class="time">
					<span class="el-icon-loading"></span>
				</div>
				<div v-else class="time">{{date}}</div>
			</div>
		</div>
		<div class="b"></div>
		<div class="c">
			<el-popover class="download" placement="bottom" width="200" trigger="click">
				<div class="qrcode">
					<img src="http://dj.jia-zhi.cn/api/qrcode/create?url=http://cdn.jia-zhi.cn/daijia/456app.1.0.27.apk" />
				</div>
				<div class="menu" slot="reference">
					<i class="el-icon-download"></i>
					<span>司机端</span>
				</div>
			</el-popover>
			<div class="info">
				<span>欢迎您，</span>
				<el-dropdown @command="onCommand">
					<span v-if="adminInfo" class="el-dropdown-link">
						{{adminInfo.name}}<i class="el-icon-arrow-down el-icon--right"></i>
					</span>
					<span v-else class="el-dropdown-link">
						-<i class="el-icon-arrow-down el-icon--right"></i>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="editphone">修改手机</el-dropdown-item>
						<el-dropdown-item command="logout">退出</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</div>
		<el-dialog title="修改手机" :visible.sync="editPhone.show" width="30%" append-to-body>
			<div class="edit-phone">
				<el-alert style="margin-bottom: 0.8rem;" title="修改成功后，需要短信登录后台" type="warning" show-icon
					:closable="false">
				</el-alert>
				<el-form label-position="top" :model="editPhone.form" :rules="editPhone.rules" ref="loginForm"
					label-width="100px">
					<el-form-item label="原手机号" prop="phone">
						<div class="yuan">-</div>
					</el-form-item>
					<el-form-item label="新手机号" prop="phone">
						<el-input v-model="editPhone.phone" placeholder="请输入新手机号码" maxlength="11" clearable />
					</el-form-item>
					<el-form-item label="确认新手机号" prop="phone">
						<el-input v-model="editPhone.phone" placeholder="请再次输入新手机号码" maxlength="11" clearable />
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="editPhone.show = false">取消</el-button>
				<el-button type="primary" size="small" :loading="editPhone.loading">确定
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				date: null,
				adminInfo: null,
				editPhone: {
					show: false,
					loading: false,
					form: {},
					rules: []
				}
			};
		},
		mounted() {
			this.setInfo();
		},
		methods: {
			setInfo() {
				const that = this;
				const info = localStorage.getItem("_JIAZHI_info");
				if (Boolean(info)) {
					that.adminInfo = JSON.parse(info);
				}
			},
			setDate() {
				var d = new Date();
				var year = d.getFullYear(); //得到年份
				var month = d.getMonth() + 1; //得到月份
				var day = d.getDate(); //得到日期
				var hour = d.getHours(); //得到小时数
				var minute = d.getMinutes(); //得到分钟数
				var second = d.getSeconds(); //得到秒数
				month = (month < 10) ? "0" + month : month;
				day = (day < 10) ? "0" + day : day;
				hour = (hour < 10) ? "0" + hour : hour;
				minute = (minute < 10) ? "0" + minute : minute;
				second = (second < 10) ? "0" + second : second;
				this.date = year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
			},
			onCommand(e) {
				const that = this;
				switch (e) {
					case "editphone":
						that.editPhone.show = true;
						break;
					case "logout":
						localStorage.removeItem("_JIAZHI_info");
						localStorage.removeItem("_JIAZHI_token");
						that.$notify({
							title: '退出成功',
							message: '您已成功退出合作商后台...',
							type: 'success',
							onClose: function() {
								that.$router.push({
									path: '/login'
								});
							}
						});
						break;
				}
			}
		}
	}
</script>

<style scoped>
	.header {
		display: flex;
		align-items: center;
		height: 3.125rem;
		font-size: 0.875rem;
	}

	.header .a {
		display: flex;
		align-items: center;
	}

	.header .a .city {
		color: #007BFF;
		font-weight: bold;
	}

	.header .a .switch {
		margin-left: 0.5rem;
		padding: 0.25rem;
		cursor: pointer;
		transform: rotate(90deg);
		border-radius: 0.25rem;
		border: 1px #ccc solid;
	}

	.header .a .switch i {
		font-size: 0.75rem;
	}

	.header .a .date {
		display: flex;
		margin-left: 1.2rem;
	}

	.header .a .date .time {
		padding-top: 0.05rem;
	}

	.header .b {
		flex: 1;
	}

	.header .c {
		display: flex;
	}

	.header .c .download {
		margin-right: 1.5rem;
	}

	.header .c .download .menu {
		display: flex;
		align-items: center;
		cursor: pointer;
	}

	.header .c .download .menu .el-icon-download {
		font-size: 1.25rem;
	}

	.header .c .download .menu span {
		font-weight: bold;
	}

	.header .c .info .el-dropdown-link {
		color: #409EFF;
		cursor: pointer;
		font-weight: bold;
	}

	.qrcode img {
		width: 100%;
	}

	.edit-phone {
		padding: 0 1.25rem;
	}

	.edit-phone .el-form-item:nth-child(1) {
		margin-bottom: 0.625rem;
	}

	.edit-phone .el-form-item:nth-child(1)>>>.el-form-item__label,
	.edit-phone .el-form-item:nth-child(1)>>>.el-form-item__content {
		line-height: 1.875rem;
	}

	.edit-phone>>>.el-form-item__label {
		padding: 0;
	}
	
	.edit-phone .yuan {
		color: black;
		font-size: 1.25rem;
		font-weight: bold;
	}
</style>
